export const environment = {
    production: false,
    apiUrl:'https://flexseat-api.dev.it-for-it.devtest.gf.aws.scania.com/api',
};
